import _ from 'lodash'
import React from 'react'
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-datepicker'
import { Field, reduxForm } from 'redux-form'
import MainAreaAddDialog from './MainAreaAddDialog'
import DefectAreaAddDialog from './DefectAreaAddDialog'
import moment from "moment/moment";

const DefectAdd = props => {
  const {
    handleSubmit, submitting, onSubmit, goBack, projects, projectId, images, imageData, uploadImage,
    searchMainArea, setMainAreaSelected, mainArea, searchDefectArea, setDefectAreaSelected, defectArea,
    searchUser, setUserSelected, assignee, authorUserId, errors, onProjectChanged, onMainAreaAddSubmit, setIsAddMainArea,
    mainAreaErrors, mainAreaList, defectAreaList, mainAreaId, setIsAddDefectArea, onDefectAreaAddSubmit, defectAreaErrors,
    users
  } = props
  if (!projects) return (<div/>)
  const projectOptions = [projects.length > 1 ? <option key={0}/> : undefined].concat(projects ?
    _.map(projects, (project) => (
      <option key={project.id} value={project.id}>{project.name}</option>
    )) : undefined)
  const image = imageData && imageData.length > 0 ? (
    <div className="row mg-t-20">
      <div className="col-sm-4 form-control-label">
        <label className="form-control-label">รูปภาพบริเวณที่เกิดข้อบกพร่อง</label>
      </div>
      <div className="col-sm-8">
        {_.map(imageData || [], (data, index) => (
          <div key={index} className="float-left mg-r-10">
            <img src={data} alt="" style={{ height: '64px', width: '64px' }}/>
          </div>
        ))}
      </div>
      <br/>
    </div>
  ) : undefined

    const mainAreaAddDialogProps = {
        onSubmit: onMainAreaAddSubmit,
        projectId,
        setIsAddMainArea,
        errors: mainAreaErrors
    }
    const defectAreaAddDialogProps = {
        onSubmit: onDefectAreaAddSubmit,
        mainAreaId,
        setIsAddDefectArea,
        errors: defectAreaErrors
    }
    console.log('DefectAdd Props :', props)
    if (projectId) {
      // onProjectChanged()
    }
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">แจ้งข้อบกพร่อง</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <form onSubmit={handleSubmit((values) => {
            onSubmit(_.merge({ projectId }, values), authorUserId, 
              mainArea.selected[0], defectArea.selected[0], assignee.selected[0], images)
          })}>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="form-layout form-layout-5">
                  <div className="">
                      <div className="row">
                        <label htmlFor="detail" className="col-sm-4 form-control-label form-label-custom">รายละเอียด :<span className="tx-danger">&nbsp;*</span></label>
                        <div className="col-sm-8">
                          <Field name="detail" component="textarea" type="text" placeholder="รายละเอียด" rows="5"
                                 className="form-control"/>
                          {errors.detail ? <span className="text-danger">{errors.detail}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="status" className="col-sm-4 form-control-label">สถานะ :</label>
                        <div className="col-sm-8">
                          <Field name="status" component="select" className="form-control">
                            <option>OPEN</option>
                          </Field>
                        </div>
                      </div>
                      
                      <div className="row mg-t-20">
                        <label htmlFor="projectId" className="col-sm-4 form-control-label">โครงการ : <span className="tx-danger">&nbsp;*</span></label>
                        <div className="col-sm-8">
                          <Field name="projectId" component="select" className="form-control"
                                 onChange={ onProjectChanged }
                          >
                            {projectOptions}
                          </Field>
                          {errors.projectId ? <span className="text-danger">{errors.projectId}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="mainArea" className="col-sm-4 form-control-label">
                          พื้นที่หลัก : <span className="tx-danger">&nbsp;*</span></label>
                        <div className={'' + ( projectId ? 'col-sm-6' : 'col-sm-8')}>
                          <AsyncTypeahead
                            disabled={!projectId}
                            multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาพื้นที่หลัก..."
                            isLoading={mainArea.isLoading || false} options={mainArea.list ? mainArea.list.rows : []}
                            onSearch={(query) => searchMainArea(query, projectId, 'mainArea')}
                            onChange={(selected) => setMainAreaSelected(selected, 'mainArea')}/>

                          {/*<Typeahead*/}
                            {/*disabled={!projectId}*/}
                            {/*multiple={false} labelKey="name" placeholder="ค้นหาพื้นที่หลัก..."*/}
                            {/*isLoading={mainArea.isLoading || false} options={mainAreaList ? mainAreaList.rows : []}*/}
                            {/*onChange={(selected) => setMainAreaSelected(selected, 'mainArea')}*/}
                            {/*paginate={true}*/}
                            {/*maxResults={5}*/}
                          {/*/>*/}
                          {errors.mainArea ? <span className="text-danger">{errors.mainArea}</span> : undefined}
                        </div>
                          {/*{*/}
                              {/*projectId &&*/}
                              {/*<div className='col-sm-2 pt-3 tx-purple'>*/}
                                  {/*<a onClick={() => { setIsAddMainArea(true, 'mainArea') }}>สร้างพื้นที่หลักใหม่</a>*/}
                              {/*</div>*/}
                          {/*}*/}

                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="defectArea" className="col-sm-4 form-control-label">
                          บริเวณที่เกิดข้อบกพร่อง: <span className="tx-danger">&nbsp;*</span></label>
                        <div className={'' + ( mainAreaId ? 'col-sm-6' : 'col-sm-8')}>
                          <AsyncTypeahead
                            disabled={!projectId}
                            multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาบริเวณที่เกิดข้อบกพร่อง..."
                            isLoading={defectArea.isLoading || false}
                            options={defectArea.list ? defectArea.list.rows : []}
                            onSearch={(query) => searchDefectArea(query, mainArea.selected[0].id, 'defectArea')}
                            onChange={(selected) => setDefectAreaSelected(selected, 'defectArea')}/>

                            {/*<Typeahead*/}
                                {/*disabled={!mainAreaId}*/}
                                {/*multiple={false} labelKey="name" placeholder="ค้นหาบริเวณที่เกิดข้อบกพร่อง..."*/}
                                {/*isLoading={defectArea.isLoading || false} options={defectAreaList ? defectAreaList.rows : []}*/}
                                {/*onChange={(selected) => setDefectAreaSelected(selected, 'defectArea')}*/}
                                {/*paginate={true}*/}
                                {/*maxResults={5}*/}
                            {/*/>*/}
                          {errors.defectArea ? <span className="text-danger">{errors.defectArea}</span> : undefined}
                        </div>
                          {/*{*/}
                              {/*mainAreaId &&*/}
                              {/*<div className='col-sm-2 pt-3 tx-purple'>*/}
                                  {/*<a onClick={() => { setIsAddDefectArea(true, 'defectArea') }}>สร้างบริเวณที่เกิดข้อบกพร่องใหม่</a>*/}
                              {/*</div>*/}
                          {/*}*/}
                      </div>
                      <div className="row mg-t-20">
                        <label htmlFor="assignee" className="col-sm-4 form-control-label">มอบหมายให้ : <span className="tx-danger">&nbsp;*</span></label>
                        <div className="col-sm-8">
                          <AsyncTypeahead
                            multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาผู้ที่เกี่ยวข้อง..."
                            isLoading={assignee.isLoading || false} options={assignee.list ? assignee.list.rows : []}
                            onSearch={(query) => searchUser(query, 'assignee')}
                            onChange={(selected) => setUserSelected(selected, 'assignee')}/>
                            {/*<Typeahead*/}
                                {/*disabled={!projectId}*/}
                                {/*multiple={false} labelKey="name" placeholder="ค้นหาผู้ที่เกี่ยวข้อง..."*/}
                                {/*isLoading={assignee.isLoading || false} options={users ? users : []}*/}
                                {/*onChange={(selected) => setUserSelected(selected, 'assignee')}*/}
                                {/*paginate={true}*/}
                                {/*maxResults={5}*/}
                            {/*/>*/}
                          {errors.assignee ? <span className="text-danger">{errors.assignee}</span> : undefined}
                        </div>
                      </div>
                      <div className="row mg-t-20">
                        <label className="col-sm-4 form-control-label"/>
                        <div className="col-sm-8">
                          <label className="custom-file">
                            <input type="file" className="custom-file-input wd-md-450" accept="image/*" multiple
                                   onChange={uploadImage}/>
                            <span className="custom-file-control"></span>
                          </label>
                        </div>
                      </div>
                      {image}
                      <div className="row mg-t-30">
                        <div className="col-sm-8 mg-l-auto">
                          <div className="form-layout-footer">
                            <button type="submit" className="btn btn-teal" disabled={submitting}>แจ้งข้อบกพร่อง</button>
                            <span>&nbsp;&nbsp;&nbsp;</span>
                            <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>กลับ</button>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
            {
                mainArea.isAddMainArea &&
                <MainAreaAddDialog {...mainAreaAddDialogProps}/>
            }
            {
                defectArea.isAddDefectArea &&
                <DefectAreaAddDialog {...defectAreaAddDialogProps}/>
            }
        </div>
      </div>    
    </div>
  )
}

export default reduxForm({
  form: 'defect-add',
  enableReinitialize: true,
})(DefectAdd)


// WEBPACK FOOTER //
// ./src/components/DefectAdd.js